module.exports = __webpack_public_path__ + "f394c5f69163e10ae13fa3bf42335064.csv";


/*****************
 ** WEBPACK FOOTER
 ** ./client/pages/inventory/samples/simple.csv
 ** module id = 1306
 ** module chunks = 0
 **/